export default __webpack_public_path__ + "static/media/2.20f49e2f.jpg";